// Desc: initial state for pcb fabrication including data when return from cart
import _ from 'lodash'
import { QUOTED, PRICE_SELECTED } from 'pu-data/QuoteSteps';

import defaultParametersCustomer from './defaultParametersCustomer';

import { findVariantIdBySupplierCode } from './productVariants';

import defaultState from './defaultState';

const state = _.cloneDeep(defaultState);

if (Spree.fabrication) {
  const { quote, quote_parameters } = Spree.fabrication
  state.quantitiesChanged = true
  state.lineItemId = Spree.fabrication.line_item_id;
  state.quote = quote;
  state.usGroups = quote.us_line_item_groups;
  state.usCombined = quote.us_line_item_combined;

  // parameters copied from line item parameters
  const copyParameter = [
    'part_number',
    'revision',
    'supplier_selected',
    'row_selected',
    'column_selected',
    'product_quote_number',
    'quote_config_key',
  ];

  if (quote.line_items) {
    const bestPriceLineItem = _.find(quote.line_items, li => (
      _.endsWith(li.quote_config_key, '-grpa')
    ));

    if (bestPriceLineItem) {
      state.parametersBestPrice = _.assign({}, defaultParametersCustomer, bestPriceLineItem.options);
      _.forEach(copyParameter, (key) => {
        state.parametersBestPrice[key] = quote_parameters[key];
      });
    }

    const customerLineItem = _.find(quote.line_items, li => (
      _.endsWith(li.quote_config_key, '-grpb')
    ));

    if (customerLineItem) {
      state.parametersCustomer = _.assign({}, defaultParametersCustomer, customerLineItem.options);
      _.forEach(copyParameter, (key) => {
        state.parametersCustomer[key] = quote_parameters[key];
      });

      if (state.parametersCustomer.has_array === '1') {
        if (state.parametersCustomer.tab_rout === '1') {
          state.parametersCustomer.array_spacing_x_tab_rout = state.parametersCustomer.array_spacing_x;
          state.parametersCustomer.array_spacing_y_tab_rout = state.parametersCustomer.array_spacing_y;
        } else if (state.parametersCustomer.scoring === '1') {
          state.parametersCustomer.array_spacing_x_vscore = state.parametersCustomer.array_spacing_x;
          state.parametersCustomer.array_spacing_y_vscore = state.parametersCustomer.array_spacing_y;
        }
      }
    }

    state.parametersCustomer.material_type_finish_plating = `${state.parametersCustomer.material_type}/${state.parametersCustomer.finish_plating}`
  }

  if (quote_parameters.supplier_selected) {
    state.quoteStep = PRICE_SELECTED;
  } else {
    state.quoteStep = QUOTED;
  }

  if (quote_parameters) {
    state.parameters = quote_parameters;
    delete state.parameters.filename;

    state.currentVariant = findVariantIdBySupplierCode(quote_parameters.supplier_selected)
  }

} else if(Spree.assembly) {
  const { part_number, revision, filename } = Spree.assembly.quote_parameters;

  state.parametersCustomer.part_number = part_number;
  state.parametersCustomer.revision = revision;
  state.parametersCustomer.filename = filename;
} else if (Spree.stencils && Spree.stencils.length > 0) {
  // if the project dont include fabrication, but include stencils take parameters from stencils
  const { parameters: stencilParmeters } = Spree.stencils[0];
  let { part_number, revision, filename } = stencilParmeters;
  if (part_number.endsWith('-Top Side')) {
    part_number = part_number.replace('-Top Side', '');
  } else if(part_number.endsWith('-Bottom Side')) {
    part_number = part_number.replace('-Bottom Side', '');
  } else if (part_number.endsWith('-Combine Top & Bottom')) {
    part_number = part_number.replace('-Combine Top & Bottom', '');
  }
  state.parametersCustomer.part_number = part_number;
  state.parametersCustomer.revision = revision;
  state.parametersCustomer.filename = filename;
} else if(Spree.parts){
  // if the project dont include fabrication, but include parts take parameters from parts
  const { part_number, revision, zip_file } = Spree.parts
  state.parametersCustomer.part_number = part_number;
  state.parametersCustomer.revision = revision;
  state.parametersCustomer.filename = zip_file;
}

export default state;